import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BrowserService } from 'src/_lib/service/browser.service';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private browser: BrowserService
  ) { }

  paginate<T>(items: T[], currentPage: number, itemsPerPage: number): T[] {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return items.slice(startIndex, endIndex);
  }

  getTotalPages(totalItems: number, itemsPerPage: number): number {
    return Math.ceil(totalItems / itemsPerPage);
  }

  getPaginatedData<T>(data: T[], currentPage: number, itemsPerPage: number): T[] {
    return this.paginate(data, currentPage, itemsPerPage);
  }

  getPagesArray(totalPages: number): number[] {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  scrollToTop(
    behavior: ScrollBehavior = 'smooth',
    bodyscroll: 'bodyscroll' | null = null
  ): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const scrollOptions: ScrollToOptions = {
      top: 0,
      left: 0,
      behavior
    };
    if (bodyscroll === 'bodyscroll') {
      if (typeof document !== 'undefined') {
      document.documentElement.scrollTo(scrollOptions);
      document.body.scrollTo(scrollOptions);
      return;
      }
    }
    this.browser.window?.scrollTo(scrollOptions);
  }
}